module.exports = __webpack_public_path__ + "img/gitlab-logo.879a78ea.png";